import React from "react";
import { get } from "lodash";
import {
  InfoOutlined,
  LockOpenOutlined,
  LockOutlined,
} from "@material-ui/icons";
import "./MemberPriceBadge.css";

const MemberPriceBadge = ({ option, client, booking, onClick, fromModality=false, raw_member_price="" }) => {
  
  // TODO double check responsiveness
  const isAddedToCart = get(
    booking,
    "cart.info_fields.soothe_pass.subscription_applied_to_cart",
    false
  );
  const memberPrice = get(option, "member_price", "");
  const fromMemberPrice = get(option, "from_member_price", "");
  const isSoothePassSubscribed = get(client, "soothe_pass.soothe_pass_subscribed", false);

  // For non-logged-in users, check availability first

  return (
    <div
      className={`member-price-badge ${isAddedToCart || isSoothePassSubscribed ? "unlocked" : "locked"}`}
      onClick={()=>{
        if(!isAddedToCart && !isSoothePassSubscribed && onClick){
          onClick()
        }
      }}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {isAddedToCart || isSoothePassSubscribed ? (
        <LockOpenOutlined className="badge-icon unlocked-icon" />
      ) : (
        <LockOutlined className="badge-icon locked-icon" />
      )}
      {fromModality ? (
        <span>
          {raw_member_price ? `$${raw_member_price}` : memberPrice ? `${memberPrice}` : fromMemberPrice} Member
        </span>
      ) : (
        <span>
          As low as {memberPrice ? `${memberPrice}` : fromMemberPrice} with
          SoothePass™
        </span>
      )}
      {!isAddedToCart && !fromModality && !isSoothePassSubscribed && <InfoOutlined className="badge-icon" />}
    </div>
  );
};

export default MemberPriceBadge;
